import type { LucideIcon } from 'lucide-react';

export type CommandPaletteDirectedSearchKind =
  | 'general_ledger_account'
  | 'customer'
  | 'customer_list'
  | 'supplier'
  | 'supplier_list'
  | 'company_user';

export type CommandPaletteDirectedSearchSectionKey =
  | 'commandPalette.sections.accounts'
  | 'commandPalette.sections.contacts'
  | 'commandPalette.sections.emailMatches';

export interface CommandPaletteDirectedSearchResult {
  id: string;
  kind: CommandPaletteDirectedSearchKind;
  title: string;
  subtitle: string | null;
  path: string;
  icon: LucideIcon;
  sectionKey: CommandPaletteDirectedSearchSectionKey;
}

export type ParsedCommandPaletteDirectedQuery =
  | { mode: 'general_ledger'; searchText: string }
  | { mode: 'customer'; searchText: string }
  | { mode: 'supplier'; searchText: string }
  | { mode: 'email'; email: string };

export const COMMAND_PALETTE_DIRECTED_MIN_SEARCH_LENGTH = 2;

export const COMMAND_PALETTE_DIRECTED_URL_KEYS = {
  LIST_SEARCH: 'q',
  VIEW: 'view',
  HIGHLIGHT_USER: 'userId',
} as const;
